<page-title text="" i18n-text="@@pageTitle.vip"></page-title>
<page-meta
    description=""
    i18n-description="@@pageMeta.description.vip">
</page-meta>
<site-layout class="full" [hideHeader]="isMobileWebView">
  <div class="wrapper">
    <section class="group-header">
      <div class="custom-row">
        <div class="header-content">
          <div class="col col-12 col-md-6 header-col">
            <div>
              <p class="green" i18n="fron.vip.label">BITOASIS VIP</p>
              <h1 class="title" >
                <ng-container *ngIf="!vip" i18n="fron.vip.title">Join the BitOasis VIP lounge</ng-container>
                <ng-container *ngIf="vip" i18n="fron.vip.title.vip">Welcome to the BitOasis VIP lounge</ng-container>
              </h1>
            </div>
            <div class="header-button">
              <h4 class="subtitle">
                <ng-container *ngIf="!vip" i18n="fron.vip.request.text">The VIP program is a benefit package designed for our high-volume traders to boost their revenue with unique support, rewards and other perks.</ng-container>
                <ng-container *ngIf="vip" i18n="fron.vip.request.text.vip">The VIP program is designed for clients like you - passionate for trading and having the highest quality standards. Your VIP benefit package includes premium service, exclusive returns and other perks.</ng-container>
              </h4>
              <div class="request-button-wrapper">
                <button *ngIf="!vip" class="btn btn-primary btn-wide" (click)="joinVip(true)" i18n="fron.vip.request.btn">Become a VIP</button>
                <a *ngIf="vip && !isMobileWebView" routerLink="/pro"class="btn btn-primary btn-wide"  i18n="fron.vip.request.btn.vip">Trade now</a>
              </div>
            </div>
          </div>
          <div class="header-image"></div>
        </div>
      </div>
    </section>
  
  <section class="group mt-5">
    <div class="referral-row">
      <div class="row-image image-referral">
      </div>
      <div class="image-column paragraph-start">
        <h3 i18n="fron.vip.info.fees.title">Exclusive fee structure</h3>
        <p i18n="fron.vip.info.fees.text">
          To support your trading activity on BitOasis, we have designed an exclusive fee structure that will allow you to significantly reduce costs on each trade. <a routerLink="/page/fees">Learn more</a> about fees.
        </p>
      </div>
    </div>

    <div class="reorder-row">
      <div class="row-image image-manager">
      </div>
      <div class="image-column paragraph-end">
        <h3 i18n="fron.vip.info.manager.title">Dedicated Account Manager</h3>
        <p i18n="fron.vip.info.manager.text">Say bye to Chatbots. Premium support will always be a WhatsApp message or a phone call away. Your dedicated account manager will assist you to solve any questions, requests or problems you have with the highest priority. You will also be a part of the VIP community group.</p>
      </div>
    </div>

    <div class="custom-row justify-content-center">
      <div class="col col-12 col-md-5 paragraph-end padding-wrap">
        <h3 i18n="fron.vip.info.onboarding.title">Seamless onboarding</h3>
        <p class="mb-0" i18n="fron.vip.info.onboarding.text">Our concierge service will guarantee you individual support throughout the sign up, verification, limit adjustment and any other onboarding step for you to start trading in no time.</p>
      </div>
      <div class="spacer"></div>
      <div class="col col-12 col-md-5 paragraph-start padding-wrap">
        <h3 i18n="fron.vip.info.referral.title">VIP referral program</h3>
        <p class="mb-0" i18n="fron.vip.info.referral.text">
          Earn attractive rewards for you and your friends. Invite your peers to BitOasis, and earn a solid percentage of all their trades. They will enjoy a cash back on each trade for 6 months.
        </p>
      </div>
    </div>
  </section>
  
  <section class="group group-padding" #joinVIP>
    <h2>
      <ng-container *ngIf="!vip" i18n="fron.vip.join.title">How to join the VIP club?</ng-container>
      <ng-container *ngIf="vip" i18n="fron.vip.join.title.vip">VIP client requirements</ng-container>
    </h2>
    <div class="info-row">
      <div class="col col-12 col-md-4">
        <div class="or or-fake">or</div>
        <h3 i18n="fron.vip.join.trader.title">Become an active trader</h3>
        <p i18n="fron.vip.join.trader.text">Your cumulative 30 day trading volume should exceed AED 200K</p>
      </div>
      <div class="col col-12 col-md-4 col-margin">
        <div class="or" i18n="fron.vip.or">or</div>
        <h3 i18n="fron.vip.join.otc.title">Make an OTC trade</h3>
        <p i18n="fron.vip.join.otc.text">
          Complete an over-the-counter (OTC) trade with a value of 100,000 USD and above <a routerLink="/otc">Learn more</a> about OTC
        </p>
      </div>
      <div class="col col-12 col-md-4 col-margin">
        <div class="or" i18n="fron.vip.or">or</div>
        <h3 i18n="fron.vip.join.get.title">Get referred by a VIP</h3>
        <p i18n="fron.vip.join.get.text">Enjoy the VIP status for 3 month even if you do not meet any other conditions</p>
      </div>
      <div class="btn-wrapper">
        <div class="request-button-wrapper">
          <a *ngIf="!vip" href="mailto:{{VIP_ADDRESS}}"  class="btn btn-primary btn-wide" i18n="fron.vip.request.btnIn">Inquire now</a>
          <a *ngIf="vip" href="mailto:{{VIP_ADDRESS}}" class="btn btn-primary btn-wide" i18n="fron.vip.request.btnIn.vip">Reach out</a>
        </div>
      </div>
    </div>
  </section>
  </div>
  <section class="group group-gray">
    <h2 class="short-title" i18n="fron.vip.related.title">Related BitOasis services</h2>
    <div class="border-block">
      <div class="paragraph-end">
        <h3 i18n="fron.vip.related.account.title">Business account</h3>
        <p i18n="fron.vip.related.account.text">Onboard your business on BitOasis to trade, receive crypto payments from your clients, integrate your platform through APIs and more</p>
        <a href="mailto:{{VIP_ADDRESS}}" class="btn btn-link p-0" i18n="fron.vip.request.btnIn">Inquire now</a>
      </div>
      <div class="paragraph-start">
        <h3 i18n="fron.vip.related.otc.title">OTC Trading Service</h3>
        <p i18n="fron.vip.related.otc.text">Make high-volume trades (USD 100,000+) without missing a price mark, any delays and at competitive prices in AED and USD.</p>
        <a routerLink="/support/otc" class="btn btn-link p-0" i18n="fron.vip.request.btnIn">Inquire now</a>
      </div>
    </div>
  </section>
</site-layout>
<site-footer *ngIf="!isMobileWebView"></site-footer>
